import React from 'react';
import { useParams } from 'react-router-dom';
import RecipeList from './RecipeList';

const CategoryView = ({ getFilteredRecipes }) => {
  const { category } = useParams();
  const filteredRecipes = getFilteredRecipes(category);

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-6 capitalize">
        {category} Recipes {filteredRecipes.length === 0 && '(No matches found)'}
      </h1>
      {filteredRecipes.length > 0 ? (
        <RecipeList recipes={filteredRecipes} />
      ) : (
        <p className="text-gray-500">No recipes match your search in this category.</p>
      )}
    </div>
  );
};

export default CategoryView;